module.exports = __webpack_public_path__ + "img/tf.bc11b76c.png";